//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import defaultimg from '@/assets/shuping/book.png'
import { stampGet } from '@/api/jianianhua'
import defautphoto from '@/assets/timg.jpg'
import { Popup, Field, List, Toast, ActionSheet, Dialog, Tab, Tabs } from 'vant'
import { getBaseTime, addComment, getBook, getAllCommentNew, getAllCommentHot, getThumbsNum, addThumbs, cancelThumbs, getAuthority, deleteComment, getBookRank } from '@/api/shuping'
export default {
  name: 'detail',
  components: {
    [Popup.name]: Popup,
    [Field.name]: Field,
    [List.name]: List,
    [ActionSheet.name]: ActionSheet,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data () {
    return {
      defautphoto: defautphoto,
      defaultimg: defaultimg,
      id: this.$route.params.id,
      baseUrl: this.$config.baseUrl,
      bookid: this.$route.params.bookid,
      detailObj: '',
      ishot: true,
      nums: '',
      showpop: false,
      comment: '',
      detailList: [],
      loading: false,
      finished: false,
      page: 1,
      rows: 3,
      showaction: false,
      actions: [{ name: '举报' }],
      activeid: '',
      tempdelete: false,
      rank: '',
      num: '',
      rulecode: ''
      // zanlist: [],
      // iszanlist: []
    }
  },
  watch: {
    ishot: function (val) {
      this.detailList = []
      this.page = 1
      this.finished = false
      this.loading = false
      // this.zanlist = []
      // this.iszanlist = []
      // this.onLoad()
    },
    tempdelete: function (val) {
      if (val) {
        this.actions = [{ name: '删除' }]
      } else {
        this.actions = [{ name: '举报' }]
      }
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  created () {
    // this.getauth()
  },
  mounted () {
    this.getbookdetail()
    this.getview()
  },
  methods: {
    getview () {
      getBaseTime({
        id: this.id
      }).then(data => {
        this.num = data.obj.num
        this.rulecode = data.obj.ruleCode
      })
    },
    addstamp () {
      stampGet({
        accountId: this.accountid,
        num: this.num,
        ruleCode: this.rulecode
      })
    },
    tab (bool) {
      this.ishot = bool
      // setTimeout(() => {
      //   window.scrollTo(0, 0)
      // }, 200)
    },
    getauth () {
      getAuthority({
        accountid: this.accountid
      }).then(res => {
        if (res.obj == 1) {
          this.actions = [{ name: '删除' }]
        }
      })
    },
    onSelect (item) {
      console.log(item.name)
      if (item.name == '举报') {
        this.$router.push({ name: 'commentReport', params: { commentid: this.activeid } })
      } else {
        Dialog.confirm({
          message: '是否需要删除！'
        })
          .then(() => {
            // on confirm
            deleteComment({
              id: this.activeid
            }).then(res => {
              if (res.success) {
                Toast.success('删除成功')
                this.detailList = []
                this.page = 1
                this.finished = false
                this.loading = false
                this.getbookdetail()
              }
            })
          })
          .catch(() => {
            // on cancel
          })
      }
    },
    getbookdetail () {
      getBook({
        id: this.bookid,
        accountid: this.accountid
      }).then(data => {
        this.detailObj = data.obj
        getBookRank({
          id: this.bookid,
          numberid: this.id
        }).then(res => {
          this.rank = res.obj
        })
      })
    },
    zan (item, index) {
      this.addstamp()
      if (!item.panduan) {
        addThumbs({
          commentid: item.id,
          accountid: this.accountid,
          bookid: this.bookid,
          numberid: this.id
        }).then(res => {
          if (res.success) {
            this.$set(this.detailList[index], 'panduan', true)
            this.$set(this.detailList[index], 'cnum', item.cnum + 1)
          }
        })
      } else {
        cancelThumbs({
          commentid: item.id,
          accountid: this.accountid,
          bookid: this.bookid,
          numberid: this.id
        }).then(res => {
          if (res.success) {
            this.$set(this.detailList[index], 'panduan', false)
            this.$set(this.detailList[index], 'cnum', item.cnum - 1)
          }
        })
      }
    },
    // 热门
    // getcommenthot () {
    //   getAllCommentHot({
    //     bookid: this.bookid,
    //     page: this.page,
    //     rows: this.rows
    //   }).then(data => {
    //     this.nums = data.obj.allCount
    //     this.len = data.obj.list
    //     this.detailList = [...this.detailList, ...data.obj.list]
    //   })
    // },
    // 最新
    // getcommentnew () {
    //   getAllCommentNew({
    //     bookid: this.bookid
    //   }).then(data => {
    //     this.detailList.push(data.obj.list)
    //   })
    // },
    onLoad () {
      if (this.ishot) {
        let _this = this
        getAllCommentHot({
          bookid: this.bookid,
          page: this.page,
          rows: this.rows
        }).then(data => {
          this.nums = data.obj.allCount
          this.detailList = [...this.detailList, ...data.obj.list]
          console.log(this.detailList)
          this.page++
          this.loading = false
          if (this.detailList.length >= this.nums) {
            this.finished = true
          }
          this.detailList.forEach((el, index) => {
            getThumbsNum({
              commentid: el.id,
              accountid: this.accountid
            }).then(res => {
              this.$set(this.detailList[index], 'cnum', res.obj.num)
              this.$set(this.detailList[index], 'panduan', res.obj.panduan)
              if (this.detailList[index].content.length < 80) {
              } else {
                this.$refs.Text[index].innerHTML = this.detailList[index].content.substring(0, 80) + '...' +
                  '<span id="showmorebtn' + this.detailList[index].id + '" style="color:#7aba4e;">展示更多</span>'
                var btn = document.getElementById('showmorebtn' + this.detailList[index].id)
                var text = document.getElementById('Text' + this.detailList[index].id)
                btn.onclick = function () {
                  console.log(_this.detailList)
                  text.innerHTML = _this.detailList[index].content
                }
              }
            })
            getAuthority({
              accountid: this.accountid,
              id: el.id
            }).then(res => {
              if (res.obj == 1) {
                this.$set(this.detailList[index], 'isde', true)
              } else {
                this.$set(this.detailList[index], 'isde', false)
              }
            })
          })
        })
      } else {
        let that = this
        getAllCommentNew({
          bookid: this.bookid,
          page: this.page,
          rows: this.rows
        }).then(data => {
          this.nums = data.obj.allCount
          this.detailList = [...this.detailList, ...data.obj.list]
          console.log(this.detailList)
          this.page++
          this.loading = false
          if (this.detailList.length >= this.nums) {
            this.finished = true
          }
          this.detailList.forEach((el, index) => {
            getThumbsNum({
              commentid: el.id,
              accountid: this.accountid
            }).then(res => {
              this.$set(this.detailList[index], 'cnum', res.obj.num)
              this.$set(this.detailList[index], 'panduan', res.obj.panduan)
              if (this.detailList[index].content.length < 80) {
              } else {
                this.$refs.Text[index].innerHTML = this.detailList[index].content.substring(0, 80) + '...' +
                  '<span id="showmorebtn' + this.detailList[index].id + '" style="color:#7aba4e;">展示更多</span>'
                var btn = document.getElementById('showmorebtn' + this.detailList[index].id)
                var text = document.getElementById('Text' + this.detailList[index].id)
                btn.onclick = function () {
                  text.innerHTML = that.detailList[index].content
                }
              }
            })
            getAuthority({
              accountid: this.accountid,
              id: el.id
            }).then(res => {
              if (res.obj == 1) {
                this.$set(this.detailList[index], 'isde', true)
                console.log(this.detailList)
              } else {
                this.$set(this.detailList[index], 'isde', false)
              }
            })
          })
        })
      }
    },
    pop (judge) {
      this.addstamp()
      if (!judge) {
        this.showpop = true
      } else {
        Toast.fail('您已点评！')
      }
    },
    submit () {
      if (this.comment.length == 0) {
        Toast({
          message: '请输入',
          position: 'bottom'
        })
        return false
      }
      addComment({
        accountid: this.accountid,
        bookid: this.bookid,
        numberid: this.id,
        content: this.comment
      }).then(res => {
        if (res.success) {
          this.showpop = false
          this.comment = ''
          Toast.success('提交成功')
          this.detailList = []
          this.page = 1
          this.finished = false
          this.loading = false
          this.getbookdetail()
        }
      })
    },
    choose (item) {
      if (item.isde) {
        this.tempdelete = true
      } else {
        this.tempdelete = false
      }
      this.activeid = item.id
      this.showaction = true
    },
    onCancel () {
      this.activeid = ''
      this.showaction = false
    },
    getMore (index) {
      this.$set(this.detailList[index], 'show', !this.detailList[index].show)
    }
  }
}
